import styled from '@emotion/styled';
import { motion } from 'framer-motion';

import { Spinner } from '~/ui/core/spinner/Spinner';

export const Container = styled(motion.div)(({ theme }) => ({
    alignItems: 'center',
    backgroundColor: theme.colors.warning[50],
    border: `1px solid ${theme.colors.warning[200]}`,
    borderRadius: theme.borderRadius.xl,
    display: 'flex',
    gap: theme.spacing['4xl'],
    justifyContent: 'space-between',
    paddingBottom: theme.spacing.m,
    paddingLeft: theme.spacing.xxl,
    paddingRight: theme.spacing.xl,
    paddingTop: theme.spacing.m,
}));

export const TextContainer = styled.div(({ theme }) => ({
    color: theme.colors.warning[800],
    flex: 1,
}));

export const Text = styled.p(({ theme }) => ({
    ...theme.typography.body.S.medium,
    margin: 0,
}));

export const ButtonContainer = styled.div(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing.m,
}));

export const variants = {
    animate: {
        opacity: 1,
        scale: 1,
    },
    exit: {
        opacity: 0,
        scale: 0.95,
    },
    initial: {
        opacity: 0,
        scale: 0.95,
    },
};

export const WarningSpinner = styled(Spinner)(({ theme }) => ({
    color: theme.colors.warning[800],
}));
